// PreloadManager.js
var PreloadManager = pc.createScript('preloadManager');

var firstScene = true;
var assetName;

PreloadManager.prototype.initialize = function() {
    PreloadManager.instance = this;
};

PreloadManager.prototype.loadSingleItem = function (assets, callback) {

    var assetsLoaded = 0;

    var onAssetReady = function () {
         assetsLoaded += 1;

        if (assetsLoaded === 1) {
            callback(true);
        }
    };

    // for (var i = 0; i < 1; i++) {
    //     if (assets.resource) {
    //         onAssetReady();
    //     } else {

    //         assets.ready(onAssetReady);
    //         this.app.assets.load(assets);
    //     }
    // }
    for (var i = 0; i < 1; i++) {
        assets.ready(onAssetReady);
        this.app.assets.load(assets);
    }
};

PreloadManager.prototype.unloadAsset = function(){
    //console.log("Temizlenen Items: " + assetName);

    var assetArray = String(assetName).split(",");

    var delAssets = [];

    for (i = 0; i < assetArray.length; i++) {

        delAssets = this.app.assets.findByTag(assetArray[i]);
        for (del = 0; del < delAssets.length; del++) {
            delAssets[del].unload();
        }
    }
};

PreloadManager.prototype.getLoadingTotalAssetCount = function() {
    let gameTextureAsset = this.app.assets.findByTag("GameTexture");
    let preloadAssets = this.app.assets.findByTag("preload");  
    let totalAsset = gameTextureAsset.length + preloadAssets.length;

    return totalAsset;
};

PreloadManager.prototype.loadMiniGameAssets = function (assetTagList, callback) {
   
    var assets = null;

    var assetArray = String(assetTagList).split(",");

    if (assetArray.length > 1) {
        assets = this.app.assets.findByTag(assetArray[0], assetArray[1], assetArray[2]);
    }
    else {
        assets = this.app.assets.findByTag(assetTagList);
    }

    if (assetName != undefined) {
        PreloadManager.instance.unloadAsset();
    }
    assetName = assetTagList;

    var assetsLoaded = 0;
    var assestTotal = assets.length;

    var onAssetReady = function (asst) {
        assetsLoaded += 1;
        LoadingManager.instance.setProgress(assetsLoaded / assestTotal);

        if (assetsLoaded === assestTotal) {
            callback(true);
        }
    };

    for (var i = 0; i < assets.length; i++) {
        if (assets[i].resource) {
            onAssetReady();
        } else {
            assets[i].ready(onAssetReady);
            this.app.assets.load(assets[i]);
        }
    }

    if (!assets.length) {
        callback(true);
    }
};

PreloadManager.prototype.loadGameAssets = function(assetTagList, callback){

    createSpawnAssetsRandomIndexArray();

    var assets = this.app.assets.findByTag(assetTagList);

    if (assetName != undefined) {
        PreloadManager.instance.unloadAsset();
    }

    assetName = assetTagList;
    
    var assetsLoaded = 0;
    var assestTotal = spawnAssetRandomIndexes.length;

    var onAssetReady = function (asst) {
        assetsLoaded += 1;
        LoadingManager.instance.setProgress(assetsLoaded / assestTotal);

        if (assetsLoaded === assestTotal) {
            callback(true);
        }
    };

    for (var i = 0; i < spawnAssetRandomIndexes.length; i++) {
        if (assets[spawnAssetRandomIndexes[i]].resource) {
            onAssetReady();
        } else {
            assets[spawnAssetRandomIndexes[i]].ready(onAssetReady);
            this.app.assets.load(assets[spawnAssetRandomIndexes[i]]);
        }
    }

    if (!spawnAssetRandomIndexes.length) {
        callback(true);
    }
};






